import React, { useEffect } from 'react';
import './DevToolsProtector.css';

const DevToolsProtector = ({ children }) => {

  useEffect(() => {
    // Disable common developer shortcuts
    const handleKeyDown = (e) => {
      // Block F12 and inspect shortcuts only
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'C')) ||
        (e.metaKey && e.altKey && (e.key === 'i' || e.key === 'I')) || // Mac
        (e.metaKey && e.altKey && (e.key === 'c' || e.key === 'C')) // Mac
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    // Add event listeners
    document.addEventListener('keydown', handleKeyDown, true);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, []);

  return (
    <div className="protected-content">
      {children}
    </div>
  );
};

export default DevToolsProtector;
